import React, { useState, useEffect, useRef } from 'react';
import '../../src/App.css';
import logo from "../components/img/GTS.png";
import icon from "../components/img/AIMaskot.png";


const SearchableDropdown = ({ 
  options, 
  value, 
  onChange, 
  placeholder, 
  required 
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const filteredOptions = options.filter(option => 
    option.name.toLowerCase().includes(searchTerm.toLowerCase()) || 
    option.code.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleSelect = (code) => {
    onChange(code);
    setIsOpen(false);
  };

  const selectedOption = options.find(option => option.code === value);

  return (
    <div className="searchable-dropdown" ref={dropdownRef}>
      <input
        type="text"
        placeholder={placeholder}
        value={isOpen ? searchTerm : (selectedOption ? `${selectedOption.name} (${selectedOption.code})` : '')}
        onChange={(e) => setSearchTerm(e.target.value)}
        onClick={() => {
          setIsOpen(true);
          setSearchTerm(''); 
        }}
        required={required}
        className="dropdown-input"
      />
      
      {isOpen && (
        <div className="dropdown-list">
          {filteredOptions.length > 0 ? (
            filteredOptions.map((option) => (
              <div 
                key={option.code} 
                className="dropdown-item"
                onClick={() => handleSelect(option.code)}
              >
                {option.name} ({option.code})
              </div>
            ))
          ) : (
            <div className="dropdown-item no-results">Нет результатов</div>
          )}
        </div>
      )}
    </div>
  );
};

const FeedbackForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    post: '',
    contact: '',
    address: '',
    requestType: '',
    message: '',
    image: '',
    fileName: '',
    consequence: '',
    customsCode: '',
    customsSystem: '',
    subjectError: '',
    requestDateTime: ''   
  });

  const [status, setStatus] = useState({ message: '', type: '' });
  const [requestTypes, setRequestTypes] = useState([]);
  const [customsSystems, setCustomsSystems] = useState([]);
  const [subjectErrors, setSubjectErrors] = useState([]);
  const [customsOffices, setCustomsOffices] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  
  // Определяем, показывать ли таможенные поля
  const showCustomsFields = formData.requestType === 'error';

  useEffect(() => {
    const fetchSelectionData = async () => {
      try {
        const fetchSelection = async (name) => {
          const response = await fetch(`https://koldoo.customs.gov.kg/koldoo/ws/public/selection/${name}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({})
          });
          const data = await response.json();
          if (data.status === 0) {
            return data.data;
          }
          return [];
        };

        const [types, systems, subjects] = await Promise.all([
          fetchSelection('feedback.request.type.selection'),
          fetchSelection('all.customs.systems.selection'),
          fetchSelection('all.customs.subject.selection')
        ]);

        setRequestTypes(types);
        setCustomsSystems(systems);
        setSubjectErrors(subjects);

        const officesResponse = await fetch('https://koldoo.customs.gov.kg/koldoo/ws/public/customs', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' }
        });

        const officesData = await officesResponse.json();
        if (officesData.status === 0 && officesData.data) {
          setCustomsOffices(officesData.data);
        } else {
          console.error("Неверная структура ответа для таможенных постов:", officesData);
        }
      } catch (error) {
        console.error('Ошибка загрузки данных:', error);
        setStatus({ message: 'Ошибка загрузки данных с сервера', type: 'error' });
      } finally {
        setIsLoading(false);
      }
    };

    fetchSelectionData();
  }, []);

  const translateRequestType = (value) => {
    const translations = {
      'review': 'Отзыв',
      'error': 'Ошибка',
      'offer': 'Предложение'
    };
    return translations[value] || value;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleCustomsCodeChange = (code) => {
    setFormData(prev => ({ ...prev, customsCode: code }));
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData(prev => ({
        ...prev,
        image: reader.result.split(',')[1],
        fileName: file.name
      }));
    };
    reader.readAsDataURL(file);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const payload = {
        ...formData,
        requestDateTime: formData.requestDateTime
          ? new Date(formData.requestDateTime).toISOString() 
          : new Date().toISOString() 
      };

      if (!payload.image) {
        delete payload.image;
        delete payload.fileName;
      }

      if (payload.requestType !== 'error') {
        delete payload.customsSystem;
        delete payload.subjectError;
      }

      console.log("Отправляемые данные:", payload);

      const response = await fetch('https://koldoo.customs.gov.kg/koldoo/ws/public/feedback', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (response.ok) {
        const feedbackNumber = await response.text();
        
        setStatus({ 
          message: `Отзыв успешно отправлен! Номер вашего отзыва: ${feedbackNumber}`, 
          type: 'success' 
        });
        
        setFormData({
          name: '',
          post: '',
          contact: '',
          address: '',
          requestType: '',
          message: '',
          image: '',
          fileName: '',
          consequence: '',
          customsCode: '',
          customsSystem: '',
          subjectError: '',
          requestDateTime: ''
        });
        window.scrollTo(0, 0);
      } else {
        const errorData = await response.json();
        setStatus({ message: `Ошибка: ${errorData.message || response.status}`, type: 'error' });
      }
    } catch (error) {
      setStatus({ message: `Сетевая ошибка: ${error.message}`, type: 'error' });
    }
  };

  if (isLoading) {
    return <div className="loading">Загрузка данных...</div>;
  }

  return (
    <div className="feedback-form-container">
      <div className="feedback-form-card">
        <div className="form-header">
          <img src={logo} alt="Feedback Icon" className="form-icon" /> 
          <h2>Форма обратной связи</h2>
          <div className="header-divider"></div>
          <p>Пожалуйста, заполните все необходимые поля для отправки запроса</p>
        </div>

        {status.message && (
          <div className={`alert ${status.type === 'success' ? 'alert-success' : 'alert-error'}`}>
            <div className="alert-message">
              <img src={icon} alt="Status Icon" className="status-icon" />
              {status.message}</div>
          </div>
        )}

        <form onSubmit={handleSubmit} className="feedback-form">
          <div className="form-section">
            <h3 className="section-title">Личные данные</h3>
            <div className="form-columns">
              <div className="form-group">
                <label>ФИО <span className="required">*</span></label>
                <input 
                  type="text" 
                  name="name" 
                  value={formData.name} 
                  onChange={handleChange} 
                  required 
                  placeholder="Иванов Иван Иванович"
                />
              </div>

              <div className="form-group">
                <label>Должность <span className="required">*</span></label>
                <input 
                  type="text" 
                  name="post" 
                  value={formData.post} 
                  onChange={handleChange} 
                  required 
                  placeholder="Ваша должность"
                />
              </div>
            </div>

            <div className="form-columns">
              <div className="form-group">
                <label>Контактные данные <span className="required">*</span></label>
                <input 
                  type="text" 
                  name="contact" 
                  value={formData.contact} 
                  onChange={handleChange} 
                  required 
                  placeholder="Телефон или email"
                />
              </div>

              <div className="form-group">
                <label>Таможенный орган <span className="required">*</span></label>
                <SearchableDropdown
                  options={customsOffices.filter(office => office.name && office.code)}
                  value={formData.customsCode}
                  onChange={handleCustomsCodeChange}
                  placeholder="Поиск по названию или коду..."
                  required={true}
                />
              </div>

              <div className="form-group">
                <label>Адрес</label>
                <input 
                  type="text" 
                  name="address" 
                  value={formData.address} 
                  onChange={handleChange} 
                  placeholder="Ваш адрес"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3 className="section-title">Детали запроса</h3>
            
            <div className="form-group">
              <label>Тип запроса <span className="required">*</span></label>
              <select 
                name="requestType" 
                value={formData.requestType} 
                onChange={handleChange} 
                required
                className="custom-select"
              >
                <option value="">Выберите тип запроса</option>
                {requestTypes.map((item, index) => (
                  <option key={item.value || index} value={item.value || ''}>
                    {translateRequestType(item.value)}
                  </option>
                ))}
              </select>
            </div>

            {showCustomsFields && (
            <div className="form-section">
              <h3 className="section-title">Таможенная информация</h3>
              <div className="form-columns">
                <div className="form-group">
                  <label>Таможенная система</label>
                  <select 
                    name="customsSystem" 
                    value={formData.customsSystem} 
                    onChange={handleChange}
                    className="custom-select"
                  >
                    <option value="">Выберите систему</option>
                    {customsSystems.map((system, index) => (
                      <option key={system.value || index} value={system.value || ''}>
                        {system.title || 'Без названия'}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Тема ошибки</label>
                <select 
                  name="subjectError" 
                  value={formData.subjectError} 
                  onChange={handleChange}
                    className="custom-select"
                >
                  <option value="">Выберите тему</option>
                  {subjectErrors.map((subject, index) => (
                    <option key={subject.value || index} value={subject.value || ''}>
                      {subject.title || 'Без названия'}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

            <div className="form-group">
              <label>Сообщение <span className="required">*</span></label>
              <textarea 
                name="message" 
                value={formData.message} 
                onChange={handleChange} 
                required 
                rows={5} 
                placeholder="Подробно опишите ваш запрос или проблему"
              />
            </div>

            <div className="form-group">
              <label>Последствия</label>
              <textarea 
                name="consequence" 
                value={formData.consequence} 
                onChange={handleChange} 
                rows={3} 
                placeholder="Опишите возможные или возникшие последствия"
              />
            </div>
          </div>

          <div className="form-section">
            <h3 className="section-title">Дополнительная информация</h3>
            
            <div className="form-columns">
              
              <div className="form-group">
                <label>Прикрепить изображение</label>
                <div className="file-upload-container">
                  <label className="file-upload-label">
                    <input 
                      type="file" 
                      accept="image/*" 
                      onChange={handleFileUpload} 
                      className="file-upload-input"
                    />
                    <span className="file-upload-button">Выбрать файл</span>
                    {formData.fileName ? (
                      <span className="file-name">{formData.fileName}</span>
                    ) : (
                      <span className="file-placeholder">Файл не выбран</span>
                    )}
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="form-actions">
            <button type="submit" className="submit-btn">
              Отправить запрос
            </button>
          </div>
        </form>
      </div>
      
      <div className="form-footer">
        <p>© 2025 Государственная таможенная служба.</p>
      </div>
    </div>
  );
};

export default FeedbackForm;